import styled from 'styled-components'
import { CaretLeft } from '@styled-icons/boxicons-regular/CaretLeft'
import { CaretDown } from '@styled-icons/boxicons-regular/CaretDown'

export const WrapperIcon = styled.span`
  display: flex;
  justify-content: center;
  width: 100%;
`

export const CaretLeftStyled = styled(CaretLeft)`
  color: #ff1744;
  cursor: pointer;
  height: 24px;
`

export const CaretDownStyled = styled(CaretDown)`
  color: #ff1744;
  cursor: pointer;
  height: 24px;
`

export const Button = styled.button`
  border: none;
  padding: 0;
`

export const P = styled.p`
  margin: 0;
`
